import * as React from 'react';
import {themeable} from '@packages/utilities/styled';
import {
  ChevronSmallDownIcon,
  ChevronSmallRightIcon,
} from '@packages/systems/spring';

const TREE_VIEW_BRANCH_SVG_PATTERN_ID = 'TREE_VIEW_BRANCH_SVG_PATTERN_ID';

export const TreeViewArrowRight = themeable(({theme: {list}}) => (
  <ChevronSmallRightIcon
    style={{
      width: 16,
      height: list.itemHeight,
    }}
  />
));

TreeViewArrowRight.displayName = 'TreeViewArrowRight';

export const TreeViewArrowDown = themeable(({theme: {list}}) => (
  <ChevronSmallDownIcon
    style={{
      width: 16,
      height: list.itemHeight,
    }}
  />
));

TreeViewArrowDown.displayName = 'TreeViewArrowDown';

/*
 * Should only be included once in the app (in DesignerSvgPatternDefinitions) so as to not have id clashes
 */
export const TreeViewBranchPattern = themeable(({theme: {list}}) => (
  <pattern
    id={TREE_VIEW_BRANCH_SVG_PATTERN_ID}
    x="0"
    y="0"
    width={list.gridBase}
    height={list.itemHeight}
    patternUnits="userSpaceOnUse"
  >
    <line
      x1="6.5"
      y1="0"
      x2="6.5"
      y2={list.itemHeight}
      stroke={list.branchColor}
      strokeWidth="1"
    />
  </pattern>
));

TreeViewBranchPattern.displayName = 'TreeViewBranchPattern';

// @ts-expect-error - TS2339 - Property 'count' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
export const TreeViewBranchSpacing = themeable(({theme: {list}, count}) => {
  const width = count * list.gridBase;
  /**
   * Enables the Navigator to target for hover + reveal effects.
   *
   * @see public/js/designer-flux/components/Navigator.jsx
   * 2023-08-24
   */
  const className = 'tree-view-branch-pattern';

  return (
    <svg
      viewBox={`0 0 ${width} ${list.itemHeight}`}
      className={className}
      width={width}
      height={list.itemHeight}
      data-automation-id="tree-branch-edge"
    >
      <rect
        fill={`url(#${TREE_VIEW_BRANCH_SVG_PATTERN_ID})`}
        x="0"
        y="0"
        width={width}
        height={list.itemHeight}
      />
    </svg>
  );
});
TreeViewBranchSpacing.displayName = 'TreeViewBranchSpacing';
